export default __webpack_public_path__ + "static/media/qr white.2c82afb4.png";